/*
 * [EDIT-COLUMNS 2026-09-28, user] Where an admin's Payments "Edit Columns" choice is remembered:
 * per admin, in this browser (the user's choice). Shared by PaymentsPage and the tab pre-loader
 * (services/prefetch.ts) so both ask the server for the IDENTICAL list — the client GET cache is
 * keyed on the params, so a pre-load without the same extraCols would never be used.
 * Storage can be missing or throw (private window, blocked site data): every read falls back to
 * "no extra columns" and every write is best-effort.
 */
export const paymentExtraColsKey = (userId: number | string | undefined | null): string =>
  `dt-payments-extra-cols:${userId ?? 'admin'}`;

export function readPaymentExtraCols(userId: number | string | undefined | null): string[] {
  try {
    const v = JSON.parse(localStorage.getItem(paymentExtraColsKey(userId)) || '[]');
    return Array.isArray(v) ? v.filter((s): s is string => typeof s === 'string' && s.length > 0) : [];
  } catch {
    return [];
  }
}

export function writePaymentExtraCols(userId: number | string | undefined | null, cols: string[]): void {
  try {
    localStorage.setItem(paymentExtraColsKey(userId), JSON.stringify(cols));
  } catch {
    /* storage blocked: the choice is kept for this visit only */
  }
}
